// extracted by mini-css-extract-plugin
export default {"button":"src-components-atoms-buttons-ota-secondary-button-ota-secondary-button-module__button--K6HUK"};